import { BaseRequest } from "api/models/request/base-request";
import { DEFAULT_PAGE_SIZE } from "commons/constants";
import { types } from "mobx-state-tree";
import { withSetPropAction } from "../../_extension/with-set-props";

export const PaginationStore = types
  .model("PaginationStore", {
    filter: "",
    sorting: "",
    pageIndex: 0,
    itemsPerPage: DEFAULT_PAGE_SIZE,
    totalItems: 0,
    totalAmount: 0,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get totalPages() {
      if (self.itemsPerPage > 0) {
        return Math.ceil(self.totalItems / self.itemsPerPage);
      }
      return 0;
    },
    get pageNumber() {
      return self.pageIndex >= 0 ? self.pageIndex + 1 : undefined;
    },
    get skipCount() {
      return (self.pageIndex || 0) * (self.itemsPerPage || 0);
    },
  }))
  .actions((self) => ({
    toBaseRequestModel: (): BaseRequest => {
      return {
        filter: self.filter,
        maxResultCount: self.itemsPerPage,
        skipCount: self.skipCount,
        sorting: self.sorting,
      };
    },
  }));
